export default __webpack_public_path__ + "static/media/Protesto-dos-professores.f93e504a.jpg";